import React from "react";
import FlatButton from 'material-ui/FlatButton';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import commonService from "core/common/service/commonService";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import mdEntityService from "core/metamodel/mdEntityService";
import {TabTemplate} from "core/common/config/mui-theme";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {preSave, IDomainObject, lovValue} from "core/form/formUtils";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import documentService from "core/document/documentService";
import DocumentTemplateForm from 'core/document/component/documentTemplateForm';
import DocumentTemplateResourceList from 'core/document/component/documentTemplateResourceList';
import {tabStyle} from 'core/common/config/variables';
import {decodeString, encodeString} from 'core/common/utils/stringUtils';
import {computeHeight} from "core/common/utils/domUtils";
import {debounce} from "core/common/utils/utils";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {DocumentTemplate} from "core/document/documentDomain";
import {action, observable} from "mobx";
import uiService from "core/common/service/uiService";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import {observer} from "mobx-react";
import {loc} from "../common/config/locales";
import RadioButtonGroup from "material-ui/RadioButton/RadioButtonGroup";
import RadioButton from "material-ui/RadioButton";
import {LovItem} from "core/metamodel/mdEntity";
import eventService from "core/event/eventService";
import StyledSelect from "core/components/fields/styledSelect";
import {Validate} from "core/form/validate";
import {optionsSearch} from "core/common/service/commonDataService";
import {MdCheckbox} from "core/components/fields/fields";
import {EmailEventHistory} from "core/event/component/historyBlocks";
import {fieldStyles} from "core/form/createForm";
import {PARTYROLE} from "party/partyDomain";


let AceEditor;

const testDataTypes: LovItem[] = [{value: 'xml', label: 'XML'}, {value: 'id', label: 'Select entity'}];

interface DocumentTemplateDetailState {
  selectedTab?: string,
  aceHeightTS?: number,
  aceHeightD?: number,
  aceHeightR?: number,
  dataStr?: string,
  resultStr?: string,
  testEntity?: LovItem,
  testObject?: any,
  testDataType?: string
}

@observer
export default class DocumentTemplateDetail extends PageAncestor<PageProps, DocumentTemplateDetailState> {

  static module = MODULE.core;
  static title = 'Document Template';
  static icon = 'file-code-o';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("DocumentTemplateDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['DocumentTemplate', "DocumentTemplateResource"], [{entity: "DOCUMENTCOMPUTATION", lov: true}, {entity: "MdEntity", lov: true}]);

    let documentPromise: Promise<DocumentTemplate>;

    if (routerParams.id === 'new') {
      let documentType  = (query.documentTypeId) ? {value: query.documentTypeId, label: query.documentTypeLabel} : null;
      documentPromise = Promise.resolve(new DocumentTemplate({
        $new: true,
        documentType,
        templateTypeId: query.templateTypeId,
        useSaxonForXslt: (query.templateTypeId === 'XSL' || query.templateTypeId === 'XSL_FO')
      } as any));
    } else {
      documentPromise = documentService.readDocumentTemplate(routerParams.id);
    }

    // webpack to takhle promisifikovane nezvladne, musi to byt normalne, je to v willMount
    // const requireEnsure = (dependencies, filename) => new Promise((resolve, reject) => {
    //     require.ensure(dependencies, resolve, filename);
    //   });
    //
    // let requirePromise = requireEnsure(['brace', 'react-ace', 'brace/mode/xml', 'brace/theme/github'], 'reactAce');


    return Promise.all([metadataPromise, documentPromise])
      .then(([entityMap, documentTemplateObject]: [any, DocumentTemplate]) => {
        documentService.documentTemplateObject = documentTemplateObject.initAfterRead(false);
      });
  }

  state: DocumentTemplateDetailState = {
    selectedTab: 'header',
    testDataType: lovValue(testDataTypes[0])
  };

  onResizeDebounced: any;

  _aceEditorTS: React.ReactInstance;
  _aceEditorR: React.ReactInstance;
  _aceEditorD: React.ReactInstance;

  aceEditorTSRefHandler = c => this._aceEditorTS = c;
  aceEditorRRefHandler = c => this._aceEditorR = c;
  aceEditorDRefHandler = c => this._aceEditorD = c;


  componentWillMount() {
    require.ensure(['react-ace', 'brace', 'brace/mode/xml', 'brace/theme/github', 'brace/ext/searchbox'], (require) => {
      if (AceEditor) {
        return;
      }

      AceEditor = (require('react-ace') as any).default;
      const brace = require("brace");
      require('brace/mode/xml');
      require('brace/theme/github');
      require('brace/ext/searchbox');

      this.forceUpdate();

    }, "reactAce");
  }


  // componentWillReceiveProps(nextProps) {
  //   //console.debug('DocumentTemplateDetail#componentWillReceiveProps, nextProps: %O', nextProps);
  //   setTimeout(() => {
  //     this.onResize();
  //   })
  // }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    this.onResizeDebounced = debounce(this.onResize, 15, false);
    window.addEventListener('resize', this.onResizeDebounced);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeDebounced);
    documentService.documentTemplateObject = null;
  }



  customValidate = (documentTemplateObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return documentService.documentTemplateObject;
  }



  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    if (!preSave(documentService.documentTemplateObject, this.customValidate)) {
      return;
    }

    documentService.saveDocumentTemplate(documentService.documentTemplateObject.prepareForServer())
      .then( action("documentTemplateSave-callback", (documentTemplateJson: IDomainObject) => {
        let wasNew = documentService.documentTemplateObject.cleanAfterSave(documentTemplateJson);
        if (wasNew) {
          this.context.router.replaceWith('documentTemplateDetail', {id: documentService.documentTemplateObject.id});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        documentService.documentTemplateObject.$errors = error.getMessages();
      });

  };

  @action onDelete = (evt) => {
    documentService.deleteDocumentTemplate(documentService.documentTemplateObject.documentType.value as string, documentService.documentTemplateObject.templateIndex)
      .then(response => {
        this.context.router.transitionTo('documentTypeDetail', {id: documentService.documentTemplateObject.documentType.value});
      }, error => {
        documentService.documentTemplateObject.$errors = error.getMessages();
      });
  };

  onAdd = (evt) => {
    console.log('onAdd');
    let query  = (documentService.documentTemplateObject.documentType) ? {
        documentTypeId: documentService.documentTemplateObject.documentType.value,
        documentTypeLabel: documentService.documentTemplateObject.documentType.label,
        templateTypeId: documentService.documentTemplateObject.templateTypeId
    } : null;
    this.context.router.transitionTo("documentTemplateDetail", {id: 'new'}, query);
  };



  handleChange = (value) => {
    console.log('handleChange newValue ', value);

    // tohle je hack, kdy zrejme pritomnost ACE editoru vyvola tento event pri psani do TextFieldu....
    if (value && value.target) {
      value.stopPropagation();
      return;
    }

    this.setState({
      selectedTab: value
    }, () => {
      this.onResize();
    });
  };

  onChangeTemplateSource = (newValue) => {
    console.log('onChangeTemplateSource');
    documentService.documentTemplateObject.templateStr = newValue;
    documentService.documentTemplateObject.$dirty = true;
  };

  onChangeTestDataType = (evt, testDataType) => {
    console.log('onChangeTestDataType ', testDataType);
    this.setState({testDataType, dataStr: "", testEntity: null, testObject: null});
  };

  onChangeData = (newValue) => {
    console.log('onChangeData');
    this.setState({dataStr: newValue});
  };

  onChangeTestEntity = (testEntity) => {
    console.log('onChangeTestEntity');
    this.setState({testEntity, testObject: null});
  };

  onChangeTestObject = (testObject) => {
    console.log('onChangeTestObject');
    this.setState({testObject});
  };




  onResize = (evt?: any) => {
    let bodyRect = document.body.getBoundingClientRect();

    let aceHeightTS = computeHeight(bodyRect, this._aceEditorTS);
    let aceHeightD = computeHeight(bodyRect, this._aceEditorD);
    let aceHeightR = computeHeight(bodyRect, this._aceEditorR);

    if (aceHeightTS || aceHeightD || aceHeightR) {
      this.setState({aceHeightTS, aceHeightD, aceHeightR});
    }
  };



  onTestEnabled = () => {
    return documentService.documentTemplateObject.templateStr && ( (this.state.testDataType === 'xml' && this.state.dataStr) || (this.state.testDataType === 'id' && this.state.testEntity && this.state.testObject) );
  };

  onTest = () => {
    let {dataStr, testEntity, testObject} = this.state;
    commonService.loading(true);
    let data = encodeString(dataStr);
    documentService.test({documentTemplate: documentService.documentTemplateObject.prepareForServer(), data, testEntity, testEntityId: lovValue(testObject)})
      .then(resultData => {

        const resultStr = (documentService.documentTemplateObject.templateTypeId === 'XSL') ? decodeString(resultData)
          : ( ((documentService.documentTemplateObject.templateTypeId === 'XSL_FO')) ? ("data:application/pdf;base64, " + resultData) : resultData);

        this.setState({resultStr, selectedTab: 'result'}, () => {
          this.onResize();
          commonService.loading(false);
        });

      });
  };


  render() {

    const {
      query
      } = this.props;

    const {aceHeightTS, aceHeightD, aceHeightR, dataStr, resultStr} = this.state;


    const propsForCreateForm = {
      dataObject: documentService.documentTemplateObject,
      rootObject: documentService.documentTemplateObject,
      entity: mdEntityService.getEntity('DocumentTemplate'),
      entities: mdEntityService.entityMap
    };

    console.debug('%c documentTemplateDetail render template %s', 'background-color: yellow', this.state.selectedTab);

    let resultElement = null;
    if (resultStr) {
      if (documentService.documentTemplateObject.templateTypeId === 'XSL') {
        if (AceEditor) {
          resultElement = <AceEditor
            mode="xml"
            theme="github"
            value={resultStr}
            readOnly={true}
            name="RESULT_DIV_ID"
            editorProps={{$blockScrolling: true}}
            width="100%"
            height={aceHeightR + "px"}
            ref={this.aceEditorRRefHandler}
            style={{padding: '5px 0 0 0'}}
          />
        } else {
          resultElement = "Loading....";
        }
      } else if (documentService.documentTemplateObject.templateTypeId === 'XSL_FO') {
        resultElement = <iframe src={resultStr} ref={this.aceEditorRRefHandler} height={aceHeightR + "px"} width="100%"/>
      }
    }

    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(documentService.documentTemplateObject, query.gridLocation)}
        <ErrorComp messages={documentService.documentTemplateObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>

        <form style={{marginTop: 10}}>


          <Tabs value={this.state.selectedTab} onChange={this.handleChange} className="detail-grid" tabTemplate={TabTemplate}
                inkBarStyle={{transition: 'inherit'}} contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} >
            <Tab label="Header" style={tabStyle} value={'header'}>
              <div className="row" style={{padding: '5px 0 0 0', width:'100%'}}>
                <div className="col-xs-12 col-sm-6">
                  <DocumentTemplateForm {...propsForCreateForm}/>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <DocumentTemplateResourceList documentTemplateObject={documentService.documentTemplateObject}
                                                entities={mdEntityService.entityMap} showType={false}
                                                />
                </div>
              </div>
            </Tab>

            <Tab label="Template source" style={tabStyle}  value={'templateSource'}>
              { (AceEditor) ?
                <AceEditor
                  mode="xml"
                  theme="github"
                  value={documentService.documentTemplateObject.templateStr}
                  onChange={this.onChangeTemplateSource}
                  name="TEMPLATE_SOURCE_DIV_ID"
                  enableBasicAutocompletion={true}
                  enableLiveAutocompletion={true}
                  editorProps={{$blockScrolling: true}}
                  width="100%"
                  height={aceHeightTS + "px"}
                  ref={this.aceEditorTSRefHandler}
                  style={{padding: '5px 0 0 0'}}
                />
                : "Loading...."}
            </Tab>
            <Tab label="Test Data" style={tabStyle}  value={'data'}>
              <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                <RadioButtonGroup name="testDataType" valueSelected={this.state.testDataType}
                                  onChange={this.onChangeTestDataType} style={{margin: "20px 0 10px 0"}}>
                  {testDataTypes.map( (format, index) => (<RadioButton key={index} value={format.value} label={format.label} style={{ display: 'inline-block', width: '25%' }}/>))}
                </RadioButtonGroup>

                {(lovValue(this.state.testDataType) === 'xml') &&
                ((AceEditor) ?
                  <AceEditor
                    mode="xml"
                    theme="github"
                    value={dataStr}
                    onChange={this.onChangeData}
                    name="DATA_DIV_ID"
                    editorProps={{$blockScrolling: true}}
                    width="100%"
                    height={aceHeightD + "px"}
                    ref={this.aceEditorDRefHandler}
                    style={{padding: '5px 0 0 0'}}
                  />
                  : "Loading....") }

                {(lovValue(this.state.testDataType) === 'id') && <div>

                  <div style={{margin: 20}}>
                    <div className="row">
                      <div className="fx col-xs-12">
                        <StyledSelect {...fieldStyles.small.styledSelect} name="testEntity" value={this.state.testEntity}  floatingLabelText="Select Entity Type"
                                      options={mdEntityService.getEntity("MdEntity").lovItems} fullWidth={true}
                                      onChange={this.onChangeTestEntity} clearable={false} />
                      </div>
                    </div>
                    { (this.state.testEntity) ? (
                      <div className="row">
                        <div className="fx col-xs-12">
                          <StyledSelect  {...fieldStyles.small.styledSelect} name="testObject" floatingLabelText="Search entity" value={this.state.testObject} async={true} asterixForAll={true}
                                         fullWidth={true} onChange={this.onChangeTestObject} clearable={false}
                                         loadOptions={optionsSearch.bind(this, lovValue(this.state.testEntity), {})}/>
                        </div>
                      </div>
                    ) : null }

                  </div>

                </div>}

              </div>
            </Tab>
            <Tab label="Result" style={tabStyle}  value={'result'}>
              {resultElement}
            </Tab>
          </Tabs>


        </form>


      </main>





    );
  }


  _createToolMenu(documentTemplateObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}>
        <ZzFlatButton onClick={this.onSave} disabled={!documentTemplateObject.$dirty} label="Save" permission={documentTemplateObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={documentTemplateObject.$new} label="New" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="DocumentTemplate" pageAncestor={this} onClick={this.onDelete} disabled={documentTemplateObject.$new} label="Delete" permission={PERMISSION.Delete}/>
        <ZzFlatButton onClick={this.onTest} disabled={!this.onTestEnabled()} label="Test"/>
      </Toolmenu>
    );
  }




}




// WEBPACK FOOTER //
// ./src/core/document/documentTemplateDetail.tsx